"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }





var _format = require('web/screens/Broadcast/format');
var _broadcastTemplate = require('shared/services/broadcastTemplate');

 const PATIENT_FIELDS = [
  { field: 'phone', label: 'Phone' },
  { field: 'first_name', label: 'First name' },
  { field: 'last_name', label: 'Last name' },
  { field: 'dob', label: 'Date of birth' },
  { field: 'mrn', label: 'MRN' },
  { field: 'email', label: 'Email' },
]; exports.PATIENT_FIELDS = PATIENT_FIELDS

const CONTACT_FIELDS = ['phone', 'email', 'mrn']
const VARIABLE_NAME = /^[a-z0-9_]+$/
const MAX_VARIABLE_NAME_LENGTH = 64



 const destinationOf = (m) => {
  if (!m || m.Destination === 'ignore') return 'ignore'
  if (m.Destination === 'variable') return 'variable'
  return `patient:${m.PatientField}`
}; exports.destinationOf = destinationOf

 const mappingFor = (
  column,
  destination,
  variable,
) => {
  if (destination === 'ignore') return { Column: column.Index, Destination: 'ignore' }
  if (destination === 'variable') return { Column: column.Index, Destination: 'variable', Variable: variable }
  return {
    Column: column.Index,
    Destination: 'patient',
    PatientField: destination.slice('patient:'.length) ,
  }
}; exports.mappingFor = mappingFor

/* Replaces one column's entry, keeping the mapping in column order. */
 const withColumnMapping = (
  mapping,
  next,
) =>
  [...mapping.filter(m => m.Column !== next.Column), next].sort((a, b) => a.Column - b.Column); exports.withColumnMapping = withColumnMapping

const patientFieldLabel = (f) =>
  _nullishCoalesce(_optionalChain([exports.PATIENT_FIELDS, 'access', _ => _.find, 'call', _2 => _2(p => p.field === f), 'optionalAccess', _3 => _3.label]), () => ( f))

/* Problems that stop the import, named by CSV header (J8). The server checks
 * the same rules; these keep Continue disabled until they're fixed. */
 const mappingErrors = (
  columns,
  mapping,
) => {
  const header = (i) => `"${_nullishCoalesce(_optionalChain([columns, 'access', _4 => _4.find, 'call', _5 => _5(c => c.Index === i), 'optionalAccess', _6 => _6.Header]), () => ( `Column ${i + 1}`))}"`
  const errors = []
  const byTarget = new Map()
  for (const m of mapping) {
    if (m.Destination === 'ignore') continue
    if (m.Destination === 'variable') {
      // Rev 24 M1: first_name and last_name come from the patient record.
      // The server's wording, with the field as the menu names it.
      const builtin = _broadcastTemplate.BUILT_IN_TEMPLATE_VARIABLES.find(b => b.Name === m.Variable)
      if (builtin) {
        errors.push(
          `${header(m.Column)} can't be the variable ${builtin.Name}: {{${builtin.Name}}} is built in and comes from the patient's record. Map the column to Patient field: ${builtin.Label} instead.`,
        )
        continue
      }
      if (!VARIABLE_NAME.test(m.Variable) || m.Variable.length > MAX_VARIABLE_NAME_LENGTH) {
        errors.push(
          `${header(m.Column)} needs a variable name of up to ${MAX_VARIABLE_NAME_LENGTH} lowercase letters, digits or underscores.`,
        )
        continue
      }
    }
    const target = m.Destination === 'variable'
      ? `the variable ${m.Variable}`
      : `the patient field ${patientFieldLabel(m.PatientField)}`
    byTarget.set(target, [...(_nullishCoalesce(byTarget.get(target), () => ( []))), m.Column])
  }
  byTarget.forEach((cols, target) => {
    if (cols.length > 1) errors.push(`${cols.map(header).join(' and ')} both map to ${target}. Pick one.`)
  })
  const hasContact = mapping.some(m => m.Destination === 'patient' && CONTACT_FIELDS.includes(m.PatientField))
  if (!hasContact) errors.push('Map a Phone, Email or MRN column so each row can be matched to a patient.')
  return errors
}; exports.mappingErrors = mappingErrors

 const formatFileSize = (bytes) =>
  bytes < 1024 ? `${bytes} B` : `${Math.max(1, Math.round(bytes / 1024))} KB`; exports.formatFileSize = formatFileSize

/* The notice after recipients are added to an existing campaign (add-recipients 05). */
 const addedNotice = ({ NewRecipients, AlreadyInCampaign }) =>
  `${_format.pluralize.call(void 0, NewRecipients, 'recipient', 'recipients')} added, Not scheduled until you send to them.` +
  (AlreadyInCampaign
    ? ` ${_format.pluralize.call(void 0, AlreadyInCampaign, 'recipient was', 'recipients were')} already in the campaign and kept their values.`
    : ''); exports.addedNotice = addedNotice
